import RaikoMaterialOutlinedInput from "../../raikoInputs/RaikoMaterialOutlinedInput";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {SnackbarHelper} from "../../../util/SnackbarHelper";
import {useEffect, useState} from "react";
import {css} from "@emotion/css";
import emptyLinkVector from "../image/aparat_video.svg"
import "./RaikoAparatVideoSelector.scss"
import img1 from "../image/help_aparat_1.jpg"
import img2 from "../image/help_aparat_2.jpg"
import img3 from "../image/help_aparat_3.jpg"
import {
    DialogSize,
    RaikoButtonSecondary,
    RaikoDefaultDialogPage, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoSectionContainer
} from "@moeindal/base-raiko-panel-components";

export default function RaikoAparatVideoSelector(
    {
        value = "",
        setVideo,

    }
) {
    useEffect(() => {
        if (typeof value !== 'undefined' && value.length > 0 && value.search("https://") >= 0) {
            setVideo(value)
        }
    }, [value])


    const loading = new LoadingHelper(useLoadingDispatcher())
    const snackbar = new SnackbarHelper(useSnackbarDispatcher())

    function getSrcFromLink(value) {
        loading.show()

        let iframeValue = ""

        value.split(" ").map((item, index) => {
            if (item.search('src=') >= 0)
                iframeValue = item.replace(`src=`, "").replaceAll('"', '')
        })

        setVideo(iframeValue)

        if (iframeValue.length === 0 && value.length > 0) {
            snackbar.showWarningMessage("کد آی فریم وارد شده صحیح نمی باشد!")
        }

        loading.hide()
    }

    const [openHelpDialogState, setOpenHelpDialogState] = useState(false);

    function handleOpenDialog() {
        setOpenHelpDialogState(true)
    }

    function handleCloseDialog() {
        setOpenHelpDialogState(false)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openHelpDialogState}
                pageTitle={"راهنما"}
                dialogSize={DialogSize.MEDIUM}
            >

                <div className={"aparatHelpBaseContainer"}>
                    <RaikoGridOneColumn className={"aparatHelpContainer"}>
                        <span>ابتدا به صفحه ی ویدیو به اشتراک گذاشته شده در آپارات بروید.</span>
                        <span>در جزئیات ویدیو ی انتخابی بعد از کلیک بر روی سه نقطه گزینه ی <strong
                            className={css`color: var(--color-primary)`}>دریافت کد امبد</strong> را انتخاب نمایید.</span>
                        <img src={img1} alt=""/>
                        <span>در قسمت بالای دیالوگ باز شده گزینه ی <strong className={css`color: var(--color-primary)`}>کد آی فریم</strong> را انتخاب کرده و مقدار درج شده در کادر را کپی نمایید.</span>
                        <img src={img2} alt=""/>
                        <span>به پیشخوان کاربری خود وارد شده و با راست کلیک بر روی کادر مشخص شده و انتخاب گزینه ی paste و یا انتخاب کادر مشخص شده و زدن کلیک های ترکیبی ctrl+v می تواندی کد آی فریم کپی شده را درج نمایید.</span>
                        <img src={img3} alt=""/>
                        <RaikoFlexAlignEnd>
                            <RaikoButtonSecondary label={"بازگشت"} onClick={handleCloseDialog}/>
                        </RaikoFlexAlignEnd>
                    </RaikoGridOneColumn>
                </div>
            </RaikoDefaultDialogPage>
            <section className={"baseAparatContainer"}>
                <RaikoSectionContainer
                    title={"آپارات"}
                >
                    <RaikoGridOneColumn>

                        <div className={"baseAparatItemsContainer"}>
                            {value && value.length > 0 ?
                                <section className={"aparatIframeContainer"}>
                                    <iframe
                                        loading='eager'
                                        title={"title"}
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture full"
                                        src={value}
                                        allowFullScreen="true"/>
                                </section> :
                                <img src={emptyLinkVector} alt={"empty video"}/>
                            }

                        </div>

                        <RaikoGridOneColumn
                            className={
                                css`
                                  flex-grow: 1;
                                  width: 100%;
                                `}>
                            <div
                                className={css`
                                  display: flex;
                                  flex-wrap: nowrap;
                                  gap: .5rem`}>
                                <RaikoMaterialOutlinedInput
                                    value={value}
                                    onChange={event => {
                                        getSrcFromLink(event.target.value)
                                    }}
                                    placeHolder={"لطفا اینجا کلیک کرده و کد آی فریم ویدیو مورد نظر خود را paste نمایید."}
                                />
                                <RaikoButtonSecondary label={"راهنما"} onClick={handleOpenDialog}/>
                            </div>
                        </RaikoGridOneColumn>

                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </section>
        </>
    )

}
